import RequestStatus from "../model/RequestStatus";
import SearchType, {ProductMatchPageResponse} from "../model/ProductMatch";

export const MERCHANT_PRODUCT_DATA_QUERY_START = 'MERCHANT_PRODUCT_DATA_QUERY_START';
export const MERCHANT_PRODUCT_DATA_QUERY_SUCCESS = 'MERCHANT_PRODUCT_DATA_QUERY_SUCCESS';
export const MERCHANT_PRODUCT_DATA_QUERY_FAILED = 'MERCHANT_PRODUCT_DATA_QUERY_FAILED';

export interface MerchantProductDataQueryStartAction {
    readonly type: string,
    readonly requestStatus: RequestStatus,
    readonly countryCode: string,
    readonly searchKey: string,
    readonly searchType: SearchType,
    readonly pageOffset: number
}

export const setMerchantProductDataQueryStart = (countryCode: string, searchKey: string, pageOffset: number): MerchantProductDataQueryStartAction => ({
    type: MERCHANT_PRODUCT_DATA_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    searchKey: searchKey,
    searchType: SearchType.MERCHANT,
    pageOffset: pageOffset
});

export interface GetMerchantProductDataQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly productData: any;
}

export const getMerchantProductDataQuerySuccessAction = (response: ProductMatchPageResponse): GetMerchantProductDataQueryComplete => ({
    type: MERCHANT_PRODUCT_DATA_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    productData: response
});

export const getMerchantProductDataQueryFailedAction = (): GetMerchantProductDataQueryComplete => ({
    type: MERCHANT_PRODUCT_DATA_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    productData: null
});

